<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="3">
      <v-text-field
          v-model="password"
          outlined
          label="Пароль"
      ></v-text-field>
      <v-btn :loading="loadingButton" @click="update" v-if="user.id">Сохранить</v-btn>
    </v-col>
    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        right
        top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import ReviewService from '../../../api/ReviewService'
    import UserService from "@/api/UserService";

    export default {
        name: 'PasswordTab',
        props: {
          value: Object,
          loading: Boolean,
        },
        components: {},
      data() {
        return {
          user: this.value,
          iikoData: null,
          loadingButton: false,
          snackbar: false,
          timeout: 2000,
          snackbarText: '',
          snackbarColor: '',
          password: ''
        }
      },
        mounted() {
        },
        watch: {

        },
        methods: {
          update(){
            if(this.password.length < 6){
              this.snackbar = true;
              this.snackbarText = 'Пароль должен быть 6 или больше символов';
              this.snackbarColor = 'error';
              return false;
            }
            this.loadingButton = true;
            var formData = this.getData();

            UserService.update(formData).then(response => {
              this.snackbar = true;
              this.snackbarText = 'Пользователь успешно обновлено';
              this.snackbarColor = 'success';
              this.password = '';
            }).catch(error => {
              this.snackbar = true;
              this.snackbarText = 'Ошибка при обновлении пользователя';
              this.snackbarColor = 'error';
            }).finally(() => (this.loadingButton = false))
          },
          getData() {
            let formData = new FormData();

            formData.append('id', this.user.id);
            formData.append('pass', this.password);
            formData.append('confirmPass', this.password);
            formData.append('fromAdmin', true);

            return formData
          }
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .iiko-data{
    margin-top: 32px;
    ul{
      li{
        display: block;

      }
    }
  }
</style>
